import React from 'react'
import QuestionCircle from 'static/images/tooltip/question-circle.svg'
import StarWithCircleGreen from 'static/images/tooltip/star_with_circle_green.svg'

import './Icon.scss'

export class Icon extends React.Component<
  {
    type: 'infinity' | 'checkmark-pricing' | 'premium-star-green' | 'question-mark'
  },
  any
> {
  public render() {
    const cls = ['zervant-icon']
    cls.push(`zervant-icon--${this.props.type}`)
    const staticImages = {
      'premium-star-green': <img className="premium-star" src={StarWithCircleGreen} />,
      'question-mark': <img className="question-mark" src={QuestionCircle} />,
    }
    return <div className={cls.join(' ')}>{staticImages[this.props.type]}</div>
  }
}
